<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <h3 class="review-title" v-if="reviews.length">
          <span class="review-score qrw-heading-md bold green-6-color">
            <span class="mr-8">{{ averageScore }}</span>
            <BaseIcon icon="thumb-up" size="sm2" />
          </span>
        </h3>
      </template>
    </Header>

    <PageContainer>
      <IQOS
        :hideTitle="true"
        v-if="!reviews.length"
        class="no-reviews gap-column-sm"
      >
        <img src="/icons/panda_hello.svg" alt="" />
        <div class="gap-row-1xs">
          <h2 class="qrw-heading-xl bold">
            {{ $t("reviews.no_review_title") }}
          </h2>
          <p class="qrw-heading-xs comment c-white pt-0">
            {{ $t("reviews.no_reviews") }}
          </p>
        </div>
      </IQOS>
      <div class="iqos-grid">
        <div class="iqos-column" id="firstColumn">
          <ReviewCard
            v-for="review in firstColumnItems"
            :unread="new_ids.includes(review._id)"
            :key="review._id"
            :review="review"
          />
        </div>
        <div
          class="iqos-column"
          id="secondColumn"
          :style="{
            visibility: in_one_column ? 'hidden' : 'visible',
          }"
        >
          <ReviewCard
            class="review-flex-item"
            v-for="review in secondColumnItems"
            :unread="new_ids.includes(review._id)"
            :key="review._id"
            :review="review"
          />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import ReviewsAPI from "@/api/reviews";

import ReviewCard from "@/components/reviews/ReviewCard.vue";

import IQOS from "@/components/IQOS.vue";

export default {
  data() {
    return {
      reviews: [],

      new_count: 0,

      new_ids: [],

      in_one_column: false,
    };
  },
  methods: {
    fetchList() {
      ReviewsAPI.getList(this.$store.state.cafe._id)
        .then((data) => {
          this.reviews = data.reviews;
          this.reviews.reverse();

          this.new_count = this.$store.state.owner.pending_reviews;

          this.new_ids = this.reviews
            .slice(0, this.new_count)
            .map((r) => r._id);

          this.$store.commit("setPendingReviewsCount", 0);
        })
        .catch((error) => {
          this.$store.dispatch("showError", "reviews_error");
        });
    },
    checkOneColumn() {
      const firstColumn = document.getElementById("firstColumn");
      const secondColumn = document.getElementById("secondColumn");

      if (!firstColumn || !secondColumn) return;

      if (secondColumn.offsetLeft <= firstColumn.offsetLeft) {
        this.in_one_column = true;
      } else {
        this.in_one_column = false;
      }
    },
  },
  computed: {
    averageScore() {
      const total = this.reviews.reduce((acc, item) => acc + item.score, 0);
      return Math.round((total / this.reviews.length) * 10) / 10;
    },
    firstColumnItems() {
      if (this.in_one_column) return this.reviews;
      return this.reviews.filter((el, index) => index % 2 == 0);
    },
    secondColumnItems() {
      if (this.in_one_column) return [];
      return this.reviews.filter((el, index) => index % 2 != 0);
    },
  },
  mounted() {
    this.fetchList();

    window.addEventListener("resize", this.checkOneColumn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOneColumn);
  },
  components: {
    ReviewCard,
    IQOS,
  },
};
</script>

<style scoped>
.review-container {
  flex-flow: row wrap;
  width: 117.1vh;

  display: flex;
  justify-content: space-between;
}

.review-score {
  display: flex;
  align-items: center;
  align-self: center;
}

.no-reviews {
  display: flex;
    align-items: center;
    justify-content: center;
}
</style>
